import { Box } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import server from "../../server";
import Banner from "./Layout/Banner";
// import FeaturedProducts from "./Layout/FeaturedProducts";
import Header from "./Layout/Header";
import SimilarProducts from "./Layout/SimilarProducts";
// import TrendingNow from "./Layout/TrendingNow";
import { subcatsToDisplay_16_9 } from "./constants";
import ViewCategory from "./Layout/ViewCategory";
// import { fileNames_16_9, subcatsToDisplay_16_9 } from "./constants";
import { HashLoader } from "react-spinners";
import PreviouslyBought from "./Layout/PreviouslyBought";
// import Wishlist from "./Layout/WishList";

const Home = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState();
  const [openSection, setOpenSections] = useState({});
  const [categoriesBySequence, setCategoriesBySequence] = useState([]);
  const [prevProductsExists, setPrevProductsExist] = useState();
  const [wishlistExists, setWishListExists] = useState();

  useEffect(() => { }, [loading]);

  const getbanners = async () => {
    const result = await axios.get(`${server}/public/banners`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      },
    });
    setItems(
      result.data.filter((item) => {
        return item.active;
      }),
    );
  };
  const getOpenSections = async () => {
    try {
      const result = await axios.get(`${server}/public/subcategories/section`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      });
      setOpenSections({
        section_1: result?.data?.section_1,
        section_2: result?.data?.section_2,
      });
    } catch (err) { }
  };

  const getCategoriesBySequence = async () => {
    try {
      const result = await axios.get(`${server}/public/sequence/Category`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      });
      setCategoriesBySequence(result.data);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchproducts = async () => {
    try {
      const result = await axios.get(`${server}/orders/recent`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      });
      if (result?.data?.products?.length > 0) {
        setPrevProductsExist(true);
      }
      // setProducts(result?.data.products.map((p) => p?.product || p));
    } catch (error) {
      console.log(error);
    }
  };

  const getWishes = async () => {
    try {
      const result = await axios.get(`${server}/user/wishlist/populated`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      });
      if (result?.data?.products?.length > 0) {
        setWishListExists(true);
      }

      // setWishlistDetails(result?.data.products.map((p) => p?.product || p));
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    // if (!localStorage.getItem("user")) navigate("/");
    // else getbanners() && getOpenSections();
    getbanners() && getOpenSections();
    getCategoriesBySequence();
    if (localStorage.getItem("user")) {
      fetchproducts();
      getWishes();
    }
  }, []);

  const [toLoad, setToLoad] = useState([0, 1]);

  return (
    <Box sx={{ marginBottom: "100px" }}>
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 9999,
          }}
        >
          <HashLoader color="#5EC401" size={100} />
        </div>
      )}
      <Header setLoading={setLoading} />

      <Banner
        min={0}
        max={2}
        items={items}
        index={1}
        toLoad={toLoad}
        setToLoad={setToLoad}
      />
      {/* <CarouselHome /> */}
      {/* <FeaturedProducts /> */}

      {/* <ViewCategory index={1} toLoad={toLoad} setToLoad={setToLoad} /> */}

      {categoriesBySequence.slice(0, 4).map((category, index) => (
        <ViewCategory
          key={category._id} // Assuming category has an _id field
          catid={category._id}
          toDisplay={subcatsToDisplay_16_9[index]} // Assuming you have a corresponding array
          bannerImg={category.imageUrl} // Adjust according to your logic
          index={index + 1} // Update index as necessary
          toLoad={toLoad}
          setToLoad={setToLoad}
        />
      ))}

      {localStorage.getItem("user") && (
        <>
          {prevProductsExists && <PreviouslyBought />}
          {/* {wishlistExists && <Wishlist />} */}
        </>
      )}
      <Banner
        min={2}
        max={6}
        items={items}
        index={5}
        toLoad={toLoad}
        setToLoad={setToLoad}
      />

      <SimilarProducts
        subCategoryId="6543c1fdf7e3ae87941ad608"
        index={6}
        toLoad={toLoad}
        setToLoad={setToLoad}
      />
      <SimilarProducts
        subCategoryId="6543c214f7e3ae87941ad773"
        index={7}
        toLoad={toLoad}
        setToLoad={setToLoad}
      />
      <Banner
        min={6}
        max={20}
        items={items}
        index={8}
        toLoad={toLoad}
        setToLoad={setToLoad}
      />
      {categoriesBySequence.slice(4, 6).map((category, index) => (
        <ViewCategory
          key={category._id} // Assuming category has an _id field
          catid={category._id}
          toDisplay={subcatsToDisplay_16_9[index]} // Assuming you have a corresponding array
          bannerImg={category.imageUrl} // Adjust according to your logic
          index={index + 9} // Update index as necessary
          toLoad={toLoad}
          setToLoad={setToLoad}
        />
      ))}
      <SimilarProducts
        subCategoryId="6543c1f7f7e3ae87941ad59b"
        index={11}
        toLoad={toLoad}
        setToLoad={setToLoad}
      />
      <SimilarProducts
        subCategoryId="65ccd7f1eca383e82c9334a4"
        index={12}
        toLoad={toLoad}
        setToLoad={setToLoad}
      />
      <SimilarProducts
        // subCategoryId="6543c1fdf7e3ae87941ad608"
        subCategoryId="6543c21bf7e3ae87941ad7e4"
        index={13}
        toLoad={toLoad}
        setToLoad={setToLoad}
      />

      {/* <SimilarProducts
        // subCategoryId="6543c1fdf7e3ae87941ad608"
        subCategoryId="6543bfd1f7e3ae87941ab66f"
        index={12}
        toLoad={toLoad}
        setToLoad={setToLoad}
      /> */}

      {/* <SimilarProducts
        // subCategoryId="6543c1fdf7e3ae87941ad608"
        subCategoryId="668bfc43fb10cd66f6cb2e69"
        index={9}
        toLoad={toLoad}
        setToLoad={setToLoad}
      />
      <SimilarProducts
        // subCategoryId="6543c1fdf7e3ae87941ad608"
        subCategoryId="668bfc43fb10cd66f6cb2e69"
        index={13}
        toLoad={toLoad}
        setToLoad={setToLoad}
      /> */}

      {/* below is the old code of the Home page  */}
      {/* <ViewCategory
        catid="6543c0c9f7e3ae87941ac44d"
        toDisplay={subcatsToDisplay_16_9[0]}
        bannerImg={fileNames_16_9[2]}
        index={1}
        toLoad={toLoad}
        setToLoad={setToLoad}
      />

      <ViewCategory
        catid="6543bfd1f7e3ae87941ab66f"
        toDisplay={subcatsToDisplay_16_9[1]}
        bannerImg={fileNames_16_9[9]}
        index={2}
        toLoad={toLoad}
        setToLoad={setToLoad}
      />

      <ViewCategory
        catid="6495da143508331f0b71bfd9"
        toDisplay={subcatsToDisplay_16_9[2]}
        bannerImg={fileNames_16_9[1]}
        index={3}
        toLoad={toLoad}
        setToLoad={setToLoad}
      />

      <TrendingNow
        openSectionData={openSection.section_1}
        index={4}
        toLoad={toLoad}
        setToLoad={setToLoad}
      />

      <ViewCategory
        catid="6543c0c9f7e3ae87941ac44d"
        toDisplay={subcatsToDisplay_16_9[3]}
        bannerImg={fileNames_16_9[7]}
        index={5}
        toLoad={toLoad}
        setToLoad={setToLoad}
      />

      <ViewCategory
        catid="6495da143508331f0b71bfd9"
        toDisplay={subcatsToDisplay_16_9[4]}
        bannerImg={fileNames_16_9[4]}
        index={6}
        toLoad={toLoad}
        setToLoad={setToLoad}
      />

      <ViewCategory
        catid="6495da143508331f0b71bfd9"
        toDisplay={subcatsToDisplay_16_9[5]}
        bannerImg={fileNames_16_9[6]}
        index={7}
        toLoad={toLoad}
        setToLoad={setToLoad}
      />

      <TrendingNow
        openSectionData={openSection.section_2}
        index={8}
        toLoad={toLoad}
        setToLoad={setToLoad}
      />

      <ViewCategory
        catid="6543c014f7e3ae87941aba4d"
        toDisplay={subcatsToDisplay_16_9[6]}
        bannerImg={fileNames_16_9[5]}
        index={9}
        toLoad={toLoad}
        setToLoad={setToLoad}
      />

      <Banner
        min={10}
        max={20}
        items={items}
        index={10}
        toLoad={toLoad}
        setToLoad={setToLoad}
      />
      <ViewCategory
        catid="6543c014f7e3ae87941aba4d"
        toDisplay={subcatsToDisplay_16_9[7]}
        bannerImg={fileNames_16_9[3]}
        index={11}
        toLoad={toLoad}
        setToLoad={setToLoad}
      />

      <ViewCategory
        catid="6543c014f7e3ae87941aba4d"
        toDisplay={subcatsToDisplay_16_9[8]}
        bannerImg={fileNames_16_9[9]}
        index={12}
        toLoad={toLoad}
        setToLoad={setToLoad}
      /> */}

      {/* <hr style={{ height: "1px", borderTop: "1px solid #f00" }} /> */}
      {/* <SimilarProducts
        subCategoryId="6543c1fdf7e3ae87941ad608"
        index={13}
        toLoad={toLoad}
        setToLoad={setToLoad}
      />
      <SimilarProducts
        subCategoryId="6543c214f7e3ae87941ad773"
        index={14}
        toLoad={toLoad}
        setToLoad={setToLoad}
      />
      <SimilarProducts
        subCategoryId="6543c1f7f7e3ae87941ad59b"
        index={15}
        toLoad={toLoad}
        setToLoad={setToLoad}
      />
      <SimilarProducts
        subCategoryId="65ccd7f1eca383e82c9334a4"
        index={16}
        toLoad={toLoad}
        setToLoad={setToLoad}
      />
      <SimilarProducts
        subCategoryId="6543c21bf7e3ae87941ad7e4"
        index={17}
        toLoad={toLoad}
        setToLoad={setToLoad}
      /> */}

      {/* <SimilarProducts categoryid="6543bfd1f7e3ae87941ab66f" /> */}
      {/* the below view is for viewing products of category i.e it shows subcat cards */}
      {/* <ViewCategory catid="64919111c55b9dcf28c39354" /> */}
      {/* <ViewCategory catid="64cdd33cc472bb70b4de3786" /> */}
      {/* <CarouselHome /> */}
      {/* <ViewCategory catid="6543bfd1f7e3ae87941ab66f" /> */}
      {/* <Banner id = '64bfcc896bedd450788672c1'/> */}

      {/* <ViewCategory
        catid="6495da143508331f0b71bfd9"
        toDisplay={[]}
        bannerImg={fileNames_16_9[1]}
        index={18}
        toLoad={toLoad}
        setToLoad={setToLoad}
      /> */}
      <div style={{ fontFamily: "Arial, sans-serif", color: "#333", lineHeight: "1.6", maxWidth: "800px", margin: "0 auto", padding: "20px" }}>

        {/* Header Section */}
        <section style={{ marginBottom: "30px", textAlign: "center" }}>
          <h2 style={{ color: "#2c3e50" }}>About Urban Bazaar & M Mart</h2>
          <p>
            <strong>Rajdhani Retail</strong> is a 7-year-old Pune-based Supermarket Company.
            We launched our first brand, <strong>Urban Bazaar</strong> (Jan 2019), as a 6,000 sq.ft physical store
            with dedicated food and non-food floors. Following its success, we opened our 2nd store,
            <strong>M Mart</strong>, in Bhawani Peth.
          </p>
        </section>

        <hr style={{ border: "0", borderTop: "1px solid #eee", margin: "20px 0" }} />

        {/* Offerings Section */}
        <section style={{ marginBottom: "30px" }}>
          <h3 style={{ color: "#2c3e50" }}>Our Products & Offers</h3>
          <p>
            We offer <strong>5,000+ products</strong> from <strong>500+ brands</strong> with daily discounts
            of <strong>4% to 55%</strong>.
          </p>
          <p style={{ fontSize: "0.9em", color: "#666" }}>
            <em>Brands include: Amul, Cadbury, Surf Excel, Tide, Gillette, Pantene, Dove, Britannia, Parle, ITC, Nestle, Colgate, Haldirams, and many more.</em>
          </p>
        </section>

        {/* Delivery Section */}
        <section style={{ backgroundColor: "#f9f9f9", padding: "20px", borderRadius: "8px" }}>
          <h3 style={{ color: "#2c3e50", marginTop: "0" }}>Delivery & Payment</h3>

          <div style={{ marginBottom: "15px" }}>
            <strong>📍 Store Pick-up</strong><br />
            Order online and pick up at <em>Urban Bazaar (Sinhgad Road)</em> or <em>M Mart (Overa Enclave, Bhawani Peth)</em>.
          </div>

          <div>
            <strong>🚚 Home Delivery</strong><br />
            Free delivery to home or office within 48 hours.
          </div>

          <div style={{ marginTop: "15px", fontSize: "0.9em" }}>
            <strong>Payment Modes:</strong> Cash/Card on Delivery or Google Pay.
          </div>
        </section>

      </div>
    </Box>
  );
};

export default Home;
